import * as React from 'react'
import { v4 as uuid } from 'uuid'

import { Label, LabelText } from '../FormItem/Label'

import { CharacterCount, StyledTextArea } from './styles'

interface TextAreaI18nText {
  optionalLabel?: string
  requiredError?: string
}
export interface TextAreaProps {
  onChange?: (value: React.ChangeEvent<HTMLTextAreaElement>) => void
  label: string
  placeholder?: string
  disabled?: boolean
  value?: string
  limit?: number
  limitText?: string
  required?: boolean
  labelHidden?: boolean
  i18nText?: TextAreaI18nText
  className?: string
  bindref?: React.RefObject<HTMLTextAreaElement>
  autoFocus?: boolean
  clearTextArea?: boolean
}

export const TextArea = (props: TextAreaProps) => {
  const {
    label,
    onChange,
    placeholder = '',
    value = '',
    limit = 1000,
    disabled = false,
    required = false,
    limitText,
    labelHidden = false,
    i18nText,
    className,
    bindref,
    autoFocus,
    clearTextArea,
  } = props

  const [text, setText] = React.useState(value.slice(0, limit))

  const internalRef = React.useRef<HTMLTextAreaElement>(null)
  const textAreaElement: React.RefObject<HTMLTextAreaElement> =
    bindref || internalRef

  const elementLabel = `${label
    .toLowerCase()
    .split(' ')
    .join('-')}-textarea-element-id`

  const id = `${elementLabel}-${uuid()}`

  React.useEffect(() => {
    setText(value.slice(0, limit))
  }, [clearTextArea, value])

  return (
    <React.Fragment>
      <Label htmlFor={id}>
        <LabelText
          required={required}
          className={labelHidden ? 'hidden' : ''}
          optionalText={(i18nText && i18nText.optionalLabel) || ''}
          disabled={disabled}
        >
          {label}
        </LabelText>
      </Label>
      <StyledTextArea
        ref={textAreaElement}
        className={className}
        id={id}
        data-testid={elementLabel}
        placeholder={placeholder}
        required={required}
        onChange={(event) => {
          setText(event.target.value.slice(0, limit))
          onChange && onChange(event)
        }}
        value={text}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      <CharacterCount>
        <span>{`${limit} ${limitText ? limitText : ''}`}</span>
        <span data-testid="counter">
          {text.length}/{limit}
        </span>
      </CharacterCount>
    </React.Fragment>
  )
}
